// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Iq1byT5o1KoAi6 {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: var(--ds-space-0, 0) 6px;
  height: 100%;
  white-space: nowrap;
}
.Iq1byT5o1KoAi6[hidden] {
  display: none;
}
`, ""]);
// Exports
export var listWrapper = `Iq1byT5o1KoAi6`;
export default ___CSS_LOADER_EXPORT___;
